import React from 'react';
import { Link } from 'react-router-dom';
// import { ChevronRightIcon } from 'lucide-react';
// import ExecutivePresenceButton from '../common/ExceutivePreBtn';

const ExecutivePresence = () => {
  return (
    <>
      <header data-aos="fade-up" className=" bg-customBlue text-yellow-400 text-center  py-4 w-full">
        <h1 className="lg:text-2xl lg:tracking-wide text-lg font-bold animate-marquee" style={{ paddingBottom: "5px", fontFamily: "Helvetica" }}>Rediscover Greatness Within</h1>
      </header>
      <div className="bg-cover bg-center w-full h-[80vh]  relative" style={{ backgroundImage: 'url("https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1")' }}>

        <div data-aos="fade-up" className="absolute  lg:mt-5  bg-black opacity-50"></div>

        <div style={{ paddingBottom: "5px", fontFamily: "Poppins" }} className="absolute inset-0 flex flex-col items-center justify-center text-white p-4 transform translate-y-14">
          <div  className="bg-gradient-to-r from-indigo-500 to-purple-500 p-6 lg:p-10 rounded-lg shadow-lg text-center">
            <h1  style={{ fontFamily: "Poppins" }}  className="text-4xl font-bold mb-4">Assess Your Executive Presence</h1>
            <p className="text-lg mb-6">Based on the insights from Coach Kshitij's acclaimed book<br />
              <strong >Demystifying Executive Presence</strong>
            </p>
            <Link
              to="/assessment"
              className="group relative inline-block"
            >
              <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-600 to-purple-600 
                                 rounded-xl opacity-75 blur-lg transition duration-500 
                                 group-hover:opacity-100 group-hover:duration-200 animate-pulse"></div>

              <button
                className="relative px-10 py-4 bg-white text-indigo-600 
                                 font-bold rounded-xl hover:text-white hover:bg-indigo-600 
                                 transition-all duration-300 transform hover:-translate-y-1 
                                 hover:shadow-2xl flex items-center group"
              >
                Assess Your Executive Presence
                <svg
                  className="ml-3 transition-transform group-hover:translate-x-2"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
                          <p className="text-lg mb-6"><br />Assessment designed by Coach Kshitij and Vivek Sharma</p>

          </div>
        </div>


      </div>
    </>
  );
};

export default ExecutivePresence;
